<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="{{fieldName}}{{index}}">
      {{ label | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="{{fieldName}}{{objectId}}" [formControlName]="fieldName"
             id="{{fieldName}}{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsValidationMessage/>
    </div>
  </div>

</form>


